export default "__VITE_ASSET__Bfw2NoJv__"